import { useIntl } from 'react-intl';
import { faCreditCard } from '@fortawesome/pro-solid-svg-icons/faCreditCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';
import { Text, TextType } from 'ui-components/components/text';

import type { PaymentMethodDetails } from '../../../financial-services-ui/types/fsui';
import { messages } from './selected-card-display.messages';

type SelectedCardDisplayProps = {
  paymentMethod: PaymentMethodDetails;
};

export const SelectedCardDisplay = ({ paymentMethod }: SelectedCardDisplayProps) => {
  const intl = useIntl();

  const label = paymentMethod.nickname || paymentMethod.paymentMethodDisplayName;
  const lastFour = paymentMethod.accountNumberLastFour;

  return (
    <FlexRow gap={Gap.Space8}>
      <FontAwesomeIcon icon={faCreditCard} />
      <Text textType={TextType.Paragraph} value={lastFour ? `${label} ***${lastFour}` : label} />
      {paymentMethod.expiration && (
        <Text textType={TextType.Caption} value={intl.formatMessage(messages.expiresLabel, { expiration: paymentMethod.expiration })} />
      )}
    </FlexRow>
  );
};
